<template>
	<div class="info-view">
		<div class="window">
			<div class="thumb" :style="{ backgroundImage: `url(${thumb})` }"></div>
			<div class="label">{{ label }}</div>
			<div class="content">
				<div v-html="content"></div>
				<a v-if="cta" class="cta" :href="cta.href" target="_blank">{{ cta.label }}</a>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			thumb: {
				type: String,
				required: true
			},
			label: {
				type: String,
				required: true
			},
			content: {
				type: String,
				required: true
			},
			cta: {
				type: Object,
				default() {
					return null;
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	.info-view {
		position: absolute;
		height: 100%;
		right: 0;
		top: 0;
		width: 220px;
		background: linear-gradient(270deg, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0) 100%);

		& > .window {
			position: absolute;
			top: 30px;
			right: 30px;
			bottom: 30px;
			width: 400px;
			background-color: #1c1820c9;
			border-radius: 8px;
			overflow: hidden;

			display: grid;
			grid-template-rows: 225px auto 1fr;

			-webkit-box-shadow: 0px 0px 6px 0px rgba(0,0,0,0.25);
			-moz-box-shadow: 0px 0px 6px 0px rgba(0,0,0,0.25);
			box-shadow: 0px 0px 6px 0px rgba(0,0,0,0.25);

			& > .thumb {
				background-size: cover;
			}

			& > .label {
				background-color: #1c1820c2;
				color: white;
				font-size: 22px;
				padding: 20px;
			}

			& > .content {
				padding: 20px;
				/* position: relative; */

				& > div {
					line-height: 24px;
				}

				& > .cta {
					transition: background-color 250ms ease-in-out;
					position: absolute;
					left: 20px;
					bottom: 20px;
					right: 20px;
					text-align: center;
					line-height: 50px;
					color: white;
					text-transform: uppercase;
					background-color: #f60;
					border-radius: 5px;

					&:hover {
						background-color: rgb(184, 73, 0);
					}
				}
			}
		}
	}

	@media only screen and (max-width: 1500px) {
		.info-view {
			& > .window {
				width: 240px;
				grid-template-rows: 150px auto 1fr;

				& > .label {
					font-size: 16px;
				}

				& > .content {
					font-size: 12px;
					
					& > div {
						line-height: 20px;
					}
				}
			}
		}
	}

	@media only screen and (max-width: 600px) {
		.info-view {
			width: 100%;

			& > .window {
				grid-template-rows: 0 auto 1fr;
				top: 100px;
				right: 5%;
				bottom: 70px;
				width: 90%;
			}
		}
	}
</style>